import { create } from "zustand";

const STORE_VARIABLES = {
  unstractSubscriptionPlan: {
    subscriptionId: null,
    planType: null,
    product: {},
    isSubscribed: false,
    isCancelled: false,
    remainingDays: 0,
    nextBillingDate: null,
  },
};
const useUnstractSubscriptionPlanStore = create((setState, getState) => ({
  ...STORE_VARIABLES,
  updateSubscriptionPlan: (details) => {
    setState({
      unstractSubscriptionPlan: {
        ...getState().unstractSubscriptionPlan,
        ...details,
      },
    });
  },
}));

export { useUnstractSubscriptionPlanStore };
